import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GradientButton from "../common/GradiantButton";
import SecondaryButton from "../common/SecondaryButton";

const HomeFinalCta = () => {
  const navigate = useNavigate();
  const theme = useSelector((s) => s.themeValue?.colors) || {};
  const start = theme.primary_gradient_start_color || "#FF2D95";

  return (
    <Box
      sx={{
        maxWidth: 900,
        mx: "auto",
        px: { xs: 2.5, sm: 4 },
        py: { xs: 5, md: 7 },
        textAlign: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: 1.4,
          textTransform: "uppercase",
          color: start,
          mb: 1,
        }}
      >
        Get Started
      </Typography>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 800,
          mb: 1.5,
          fontSize: { xs: "1.5rem", md: "2rem" },
          color: theme.text || "#1a1220",
        }}
      >
        A Better Tomorrow, Together
      </Typography>
      <Typography
        sx={{ color: "text.secondary", mb: 3, maxWidth: 480, mx: "auto" }}
      >
        Let&apos;s turn your real estate goals into reality.
      </Typography>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.5}
        justifyContent="center"
        alignItems="center"
      >
        <GradientButton
          text="Explore Properties"
          onClick={() => navigate("/properties")}
          width={{ xs: "100%", sm: 200 }}
          height={46}
        />
        <SecondaryButton
          text="Contact Us"
          onClick={() => navigate("/contact")}
          width={{ xs: "100%", sm: 160 }}
          height={46}
        />
      </Stack>
    </Box>
  );
};

export default HomeFinalCta;
